export const listMeterAssignments = `
   query listMeterAssignments($filter: MeterAssignmentsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listMeterAssignments(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              meterId
              sortKey
              channel
              channelIdentifiers
              freeTierQuantity
              status
              effectiveFrom
              effectiveTo
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMeterAssignment = `
   query getMeterAssignment($id:ID!) {
       getMeterAssignment(id:$id) {
         id
         customerId
         meterId
         sortKey
         channel
         channelIdentifiers
         freeTierQuantity
         status
         effectiveFrom
         effectiveTo
         createdByUsername
         created
         updated
       }
}`;
